import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import {
  BeginWebhookIntegrationRequest,
  WebhookIntegrationRecord,
} from "../WebhookIntegrationRecord";

export function useBeginWebhookIntegration() {
  const { integrationService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<
    WebhookIntegrationRecord,
    Error,
    BeginWebhookIntegrationRequest
  >({
    mutationFn: ({ orgId, userConfig, webhookProvider, webhookEvents }) => {
      return integrationService
        .beginWebhookIntegration({
          orgId,
          userConfig,
          webhookProvider,
          webhookEvents,
        })
        .then((response) => {
          queryClient.setQueryData(
            ["webhookEndpointId", response.webhook_endpoint_id],
            response,
          );

          void queryClient.invalidateQueries({
            queryKey: ["foxgloveIntegration", orgId],
          });

          return response;
        });
    },
  });
}
